// start here for web `<Heading />`
import Heading from './heading/Heading';
export default Heading;